import { CardHeader } from "@/components/layout/MainCard"
import { Card, CardContent, CardTitle } from "@/components/ui/card"
import { cn } from "@/lib/utils"

export function FaqCard({ className }: { className: string }) {
  return (
    <Card className={cn("overflow-auto p-6", className)}>
      <CardHeader>
        <CardTitle>FAQ</CardTitle>
        <CardContent className="p-0">
          <h2 className="mb-1 font-bold">What Is A Funding Request?</h2>
          <p className="mb-4">
            A Funding Request is where you tell us how much capital you need and
            what you need it for. It keeps all your lender applications for that
            specific need in one place.
          </p>
          <h2 className="mb-1 font-bold">Why Apply To More Lenders?</h2>
          <p>
            Applying to more lenders increases your chances of getting multiple
            offers – so you can compare and choose the best one for your needs.
          </p>
        </CardContent>
      </CardHeader>
    </Card>
  )
}
